import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, useNavigate, useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import filter from 'ramda/src/filter';
import find from 'ramda/src/find';
import isEmpty from 'ramda/src/isEmpty';
import propEq from 'ramda/src/propEq';
import Dropdown from '@components/@core/Dropdown';
import NotFound from '@components/NotFound';
import ProfileHeader from '@components/ProfileHeader';
import AppActions from '~/actions/app';
import CommunityActions from '~/actions/community';
import { PROFILE_MOBILE_TABLIST } from '~/services/constants';
import About from '~/views/Community/Community/Profile/About';
import Blog from '~/views/Community/Community/Profile/Blog';
import BlogAdmin from '~/views/Community/Community/Profile/BlogAdmin';
import AccountAdmin from '~/views/Community/Community/Profile/AccountAdmin';
import Connections from '~/views/Community/Community/Profile/Connections';
import { api } from '~/sagas';

//@TODO: Not sure if this works post-migration, but this may not be required.
const TABS = [
    { id: 1, name: 'about', label: 'About' },
    //{ id: 2, name: 'blog', label: 'Blog' },
    //{ id: 3, name: 'connections', label: 'Connections' },
    // { id: 4, name: 'recommendations', label: 'Recommendations' },
];
const OPTIONS = [
    { id: 0, name: 'account-admin', label: 'Account Admin' },
    // { id: 1, name: 'blog-admin', label: 'Blog Admin' },
    // { id: 2, name: 'reports', label: 'Reports' },
];

const Profile = (props) => {
    const _user = props?.user;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const loginUser = useSelector((state) => state.app.user?.community_user);
    const authenticated = !isEmpty(useSelector((state) => state.app.token));
    const blogs = useSelector((state) => state.community.communityBlogs);
    const blogsPost = useSelector((state) => state.community.blogs);

    const [editable, setEditable] = useState(false);
    const [defaultId, setDefaultId] = useState(0);
    const [profile, setProfile] = useState();

    const mobileRoute = OPTIONS.length === 1 ? TABS.concat(OPTIONS) : PROFILE_MOBILE_TABLIST;
    const blog = find((e) => e?.entity?.slug === params.entity || e?.slug === params.entity, blogs);
    const isBlogAdmin = !!find(propEq('id', loginUser?.community_user?.id), blog?.admins || []);
    const user = (params?.entity ? blog?.entity?.user : params?.post) || _user || loginUser;
    
    const facebook = user?.profile?.facebook;
    const twitter = user?.profile?.twitter;
    const linkedin = user?.profile?.linked_in;
    const youtube = user?.profile?.youtube;
    const premiumBlogs = blogsPost?.premium?.posts?.data || [];

    const getCommunityUserDetail = () => {
        if (!params?.post || !params?.entity) {
            if (authenticated) {
                dispatch(CommunityActions.getcommunityuserRequest({ userId: loginUser.id }, null, null, null, false));
            }
        } else {
            if (blog?.user_id) {
                dispatch(CommunityActions.getcommunityuserRequest({ userId: blog?.user_id, blogId: blog?.blog?.id }, null, null, null, false));
            }
        }
    };

    const handleSelectOption = (e) => {
        if (e === 'edit') setEditable(true);
    };

    const handleCancelEdit = () => {
        setEditable(false);
        getCommunityUserDetail();
    };

    const handleConnectCallBack = () => {
        toast.success('Connection Request has been sent', {
            position: toast.POSITION.TOP_RIGHT,
            pauseOnFocusLoss: false,
            hideProgressBar: true,
        });
        dispatch(AppActions.fetchnotificationsRequest());
    };

    const handleConnect = () => {
        if (blog?.user_id) {
            const payload = { user_id: loginUser?.community_user?.id, connect_user_id: user.id };
            const after = { type: 'GETUSERCONNECTIONS_REQUEST' };
            dispatch(CommunityActions.postcommunityconnectRequest(payload, null, after, handleConnectCallBack));
        }
    };

    const handleLogin = () => {
        const route = history.location.pathname;
        dispatch(AppActions.modalRequest({ type: 'Authentication', data: { before: { route } } }));
    };

    const handleTabs = (e) => {
        navigate(`/${params.entity}/${e[0].name}${location.search}`);
        setDefaultId(e[0].id);
    };

    const handleChangeProfile = (e) => () => {
        switch (e) {
            case 'avatar':
                dispatch(
                    AppActions.modalRequest({
                        type: 'Upload Vendor Avatar',
                        data: {
                            before: {
                                entity: user?.entity?.id,
                                userId: user?.hcm_user_id,
                                title: 'Avatar image will be converted into 175 x 175',
                            },
                        },
                        callBack: () => {
                            getCommunityUserDetail();
                        },
                    })
                );
                break;

            case 'cover':
                dispatch(
                    AppActions.modalRequest({
                        type: 'Upload Background Image',
                        data: {
                            before: {
                                entity: user?.entity?.id,
                                title: 'Cover Image will be converted into 1145 x 220',
                            },
                        },
                        callBack: () => {
                            getCommunityUserDetail();
                        },
                    })
                );
                break;

            case 'social':
                dispatch(
                    AppActions.modalRequest({
                        type: 'Link Social Networks',
                        data: { before: { user } },
                        callBack: getCommunityUserDetail,
                    })
                );
                break;

            default:
                break;
        }
    };

    useEffect(() => {
        getCommunityUserDetail();
    }, []);

    useEffect(() => {
        const fetchBlogSlug = async () => {
            if (params?.entity && params?.post && !user && !profile) {
                const res = await api.getBlogSlug(params.entity, params.post);
                if (res.ok) {
                    setProfile(res.data?.user);
                }
            }
        };
        
        fetchBlogSlug();
    }, [params]);

    let _TABS = TABS;
    if (!blog?.has_blog) {
        _TABS = filter((x) => x.name !== 'blog', TABS);
    }
    let _OPTIONS = OPTIONS;
    if (loginUser?.id !== blog?.user_id) _OPTIONS = [];

    return (
        <div className="community-profile main w-100">
            <ProfileHeader
                type="employee"
                editable={editable}
                avatar={(user ?? profile)?.avatar}
                banner={(user ?? profile)?.cover_url}
                user={user ?? profile}
                title={`${(user ?? profile)?.first_name || (user ?? profile)?.email || 'User'} ${(user ?? profile)?.last_name || ''}`}
                description={`Company: ${(user ?? profile)?.profile?.company ?? (user ?? profile)?.profile?.experience?.[0]?.company ?? ''}`}
                initialTab={1}
                rootPath={'/' + params.entity}
                routes={{ tabs: _TABS, options: _OPTIONS }}
                query={location.search}
                facebook={facebook}
                twitter={twitter}
                linkedin={linkedin}
                youtube={youtube}
                onLogin={handleLogin}
                onChange={handleChangeProfile}
                // onDropdown={e => setIndex(e)}
                onSelect={handleSelectOption}
                onConnect={handleConnect}
            />
            <Dropdown className="mobile-screen text-capitalize" data={mobileRoute} defaultIds={[defaultId]} returnBy="data" getValue={(e) => e.name} onChange={handleTabs} />
            <Routes>
                { /*<Route path="activity" element={<div />} /> */}
                <Route path="/" element={params.product === 'about' ? <About user={user} editable={editable} avatar={user?.avatar} cover={user?.cover_url} onLogin={handleLogin} onCancel={handleCancelEdit} /> : <NotFound />} />
           { /* <Route path="blog" element={<Blog editable={isBlogAdmin} data={blog} premiumBlogs={premiumBlogs} />} />
                <Route path="blog/:post" element={<Blog editable={isBlogAdmin} data={blog} premiumBlogs={premiumBlogs} />} />
                <Route path="connections" element={<Connections user={user} connections={blog?.connections} onLogin={handleLogin} />} />
                <Route path="recommendations" element={<p className="dsl-b20">My Recommendations</p>} />
                <Route path="account-admin" element={<AccountAdmin user={user} />} />
                <Route path="blog-admin" element={<BlogAdmin blog={blog} user={user} onBlogDetail={() => {}} />} />
                <Route path="reports" element={<p className="dsl-b20">Reports Page</p>} /> 
            */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </div>
    );
};

export default memo(Profile);
